import { ExperienceTemplateRenderer, TemplateComponentProps } from 'experience-template-renderer-react';
import * as React from 'react';

import { UitkLayoutGrid } from 'uitk-react-layout-grid';

import { z } from 'zod';

export const LayoutGrid: React.FC<TemplateComponentProps> = ({ templateComponent }) => {
  const { children, config } = templateComponent;

  const configSchema = z.optional(
    z.object({
      columns: z.number(),
    })
  );
  const result = configSchema.safeParse(config);

  if (!result.success || !children || children.length === 0) {
    return null;
  }

  const { columns } = result.data ?? {};

  return <UitkLayoutGrid columns={columns}>{children && <ExperienceTemplateRenderer templateComponents={children} />}</UitkLayoutGrid>;
};
